import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { GAP_IF_UNDEFINED } from "./constants"

const DEFAULT_IMAGE_URL =
  "https://embed.filekitcdn.com/e/a2FfsUPzgBp4oK4mu343Uf/9KjU8dZ8YTUJDh4fm3G3aV"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-articlecards td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }
    .ck-articlecards td:first-of-type {
      margin-bottom: 32px !important;
    }
  }
  .ck-articlecards div a { margin-top: 16px }
`

export function ArticleCards({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const contentStyle = {
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding
  }

  const cardStyle = {
    backgroundColor: properties.backgroundColor,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderStyle: "solid",
    overflow: "hidden"
  }

  const gap =
    (properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap) / 2

  return (
    <div className="ck-articlecards ck-layout-block-template">
      <table border="0" cellPadding="0" cellSpacing="0" width="100%">
        <tbody>
          <tr>
            <td
              width="50%"
              style={{
                paddingRight: gap
              }}
            >
              <div style={cardStyle}>
                <EditableImage
                  name="left_image"
                  src={properties.left_image || DEFAULT_IMAGE_URL}
                  alt={properties.left_alt}
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: 0
                  }}
                />
                <div style={contentStyle}>
                  <LiteSlateEditor block_id={children[0].block_id} />
                </div>
              </div>
            </td>
            <td
              width="50%"
              style={{
                paddingLeft: gap
              }}
            >
              <div style={cardStyle}>
                <EditableImage
                  name="right_image"
                  src={properties.right_image || DEFAULT_IMAGE_URL}
                  alt={properties.right_alt}
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: 0
                  }}
                />
                <div style={contentStyle}>
                  <LiteSlateEditor block_id={children[1].block_id} />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
